import { LivePostEventSections } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/live/sections.connect';
import { FC } from 'react';

type LiveFormContentProps = Readonly<{ tabId: string }>;

export const LiveFormContent: FC<LiveFormContentProps> = ({ tabId }) => (
  <>
    <LivePostEventSections.ConnectedProductSummary tabId={tabId} />
    <LivePostEventSections.ConnectedTradeInformation tabId={tabId} isModification={true}>
      <LivePostEventSections.ConnectedPricingInformation tabId={tabId} />
    </LivePostEventSections.ConnectedTradeInformation>
    <LivePostEventSections.ConnectedLiveSalesMarginInformation tabId={tabId} />
    <LivePostEventSections.ConnectedBookingInformation tabId={tabId} />
  </>
);

LiveFormContent.displayName = 'LiveFormContent';
